import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetProfessionalOverviewUseCaseInterface } from 'domain/usecases';

export class RemoteGetProfessionalOverview
  implements GetProfessionalOverviewUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetProfessionalOverviewUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetProfessionalOverviewUseCaseInterface.Params,
  ): Promise<GetProfessionalOverviewUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${id}`, restParams),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse?.body?.message);
    }
  }
}
